import React from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';

interface DualAxisChartProps {
  data: any;
}

const DualAxisChart: React.FC<DualAxisChartProps> = ({ data }) => {
  const getOption = (): EChartsOption => {
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      legend: {
        data: ['收缩压', '舒张压', '血糖']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: data.dates,
        axisPointer: {
          type: 'shadow'
        }
      },
      yAxis: [
        {
          type: 'value',
          name: '血压 (mmHg)',
          min: 50,
          max: 200,
          position: 'left',
          axisLine: {
            show: true,
            lineStyle: { color: '#ff4d4f' }
          },
          axisLabel: { formatter: '{value}' }
        },
        {
          type: 'value',
          name: '血糖 (mmol/L)',
          min: 2,
          max: 15,
          position: 'right',
          axisLine: {
            show: true,
            lineStyle: { color: '#1890ff' }
          },
          axisLabel: { formatter: '{value}' },
          splitLine: { show: false }
        }
      ],
      series: [
        {
          name: '收缩压',
          type: 'line',
          yAxisIndex: 0,
          data: data.bpSystolic,
          smooth: true,
          connectNulls: true,
          itemStyle: { color: '#ff4d4f' }
        },
        {
          name: '舒张压',
          type: 'line',
          yAxisIndex: 0,
          data: data.bpDiastolic,
          smooth: true,
          connectNulls: true,
          itemStyle: { color: '#ffa39e' }
        },
        {
          name: '血糖',
          type: 'line',
          yAxisIndex: 1,
          data: data.bsValues,
          smooth: true,
          connectNulls: true,
          itemStyle: { color: '#1890ff' }
        }
      ]
    };
  };

  return (
    <ReactECharts
      option={getOption()}
      style={{ height: 400 }}
      opts={{ renderer: 'svg' }}
    />
  );
};

export default DualAxisChart;
